import { IconButton, styled } from '@mui/material'

export const StyledIconButton = styled(IconButton)(() => ({
    position: 'relative',
    background: '#ffffff',
    color: '#5A5F72',
    backgroundClip: 'padding-box',
    border: '2px solid transparent',
    padding: 0,
    zIndex: 0,
}))
